import clsx from "clsx";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import useValidation from "../../validation/useValidation";
import { CriterionLabel } from "../common/CriterionLabel";
import { SearchCriterion } from "../common/SearchCriterion";
import SimpleCheckbox from "./SimpleCheckbox";
import { requiredRolesType } from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";

export const BOOLEAN_CHECKBOX_CRITERION_INITIAL_STATE = "";

interface BooleanCheckboxCriterionProps {
	criterionKey: string;
	label: string;
	choice: string;
	requiredRoles?: requiredRolesType;
	visibilitySelector?: visibilitySelectorType;
	prefix?: string;
	quickSearch?: boolean;
}

export function BooleanCheckboxCriterion({
	choice,
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	visibilitySelector,
}: BooleanCheckboxCriterionProps) {
	const { currentInput, onInputChange } = useFormComponentState(
		criterionKey,
		BOOLEAN_CHECKBOX_CRITERION_INITIAL_STATE,
	);
	const { valid, message } = useValidation(criterionKey);
	const inputId = `${criterionKey}${quickSearch ? "_quick_search" : ""}`;

	const handleToggle = () => {
		const newInput = currentInput === "true" ? "false" : "true";
		onInputChange(newInput);
	};

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<div
				className={clsx("criterion boolean-criterion", {
					error: !valid,
				})}
			>
				<label htmlFor={inputId}>
					<CriterionLabel label={label} prefix={prefix} />
				</label>

				{!valid && <span className="error-text">{message}</span>}

				<SimpleCheckbox
					itemKey={criterionKey}
					value={choice}
					checked={currentInput === "true"}
					onToggle={handleToggle}
					inputId={inputId}
				/>
			</div>
		</SearchCriterion>
	);
}
